const firebaseConfig = {
    apiKey: "AIzaSyDlYOv1hwxMkHA-sSX10m0S2rmMJpUlS_0",
    authDomain: "medi-care-assignment-10.firebaseapp.com",
    projectId: "medi-care-assignment-10",
    storageBucket: "medi-care-assignment-10.appspot.com",
    messagingSenderId: "400037740539",
    appId: "1:400037740539:web:b53295ddad8693e73a955e"
};

export default firebaseConfig;